var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutBase',[_c('div',{class:{ 'mobile_container': true, 'is-admin': _vm.isAdmin }},[_c('div',{staticClass:"mobile_header"},[_c('mobile-header')],1),_vm._v(" "),_c('main',{staticClass:"mobile_main"},[_vm._t("default")],2),_vm._v(" "),_c('div',{attrs:{"id":"page-modals"}},[_c('hash-modals'),_vm._v(" "),_vm._t("modals")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }